import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  IoHomeOutline,
  IoTimeOutline,
  IoTicketOutline,
  IoHelpCircleOutline,
  IoCalendarOutline,
  IoPeopleOutline,
  IoStatsChartOutline,
  IoPersonCircleOutline,
  IoLogInOutline,
} from "react-icons/io5";
import { AuthContext } from "./AuthContext";

export default function Layout({ children }) {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const regularMenuItems = [
    { name: "Home", icon: <IoHomeOutline />, link: "/" },
    { name: "Book Later", icon: <IoTimeOutline />, link: "/book-later" },
    { name: "Bookings", icon: <IoTicketOutline />, link: "/bookings" },
    { name: "Support", icon: <IoHelpCircleOutline />, link: "/support" },
  ];

  const adminMenuItems = [
    { name: "Availability", icon: <IoCalendarOutline />, link: "/reservations" },
    { name: "User Activity", icon: <IoPeopleOutline />, link: "/logs" },
    { name: "Statistics", icon: <IoStatsChartOutline />, link: "/statistics" },
  ];

  return (
    <section className="App" aria-label="Application layout">
  <aside className="sidebar">
        <header className="sidebar-header">
          <h1>
            <strong className="clip">clip</strong>
            <strong className="board">.board</strong>
          </h1>
        </header>

        <nav aria-label="Main">
          <ul className="menu-list">
            {regularMenuItems.map((item, index) => {
              const isActive = location.pathname === item.link;
              return (
                <li key={index}>
                  <Link
                    to={item.link}
                    className={`menu-link ${isActive ? "active-menu" : ""}`}
                    aria-current={isActive ? "page" : undefined}
                  >
                    {item.icon}
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {user && user.role === "Admin" && (
          <section className="admin-container">
            <h3>Admin Options</h3>
            <nav aria-label="Admin">
              <ul className="menu-list">
                {adminMenuItems.map((item, index) => {
                  const isActive = location.pathname === item.link;
                  return (
                    <li key={index}>
                      <Link
                        to={item.link}
                        className={`menu-link ${isActive ? "active-menu" : ""}`}
                        aria-current={isActive ? "page" : undefined}
                      >
                        {item.icon}
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </section>
        )}

        <footer className="bottom-menu">
          {user ? (
            <nav className="profile-menu" aria-label="Profile">
              <Link to="/profile" className="menu-link" aria-label="Profile">
                <IoPersonCircleOutline size={28} aria-hidden="true" />
              </Link>
            </nav>
          ) : (
            <Link to="/login" className="login-button" aria-label="Login">
              <IoLogInOutline aria-hidden="true" />
              Login
            </Link>
          )}
        </footer>
      </aside>

      <main className="content" role="main">
        {children}
      </main>
    </section>
  );
}